import React from "react";
import close from "../../../assets/images/model/close.svg";
const UploadVideo = ({ setUploadVideo, setUploadingVideo, setUploadBook }) => {
  // const [uploadLoadingBook, setUploadLoadingBook] = useState(false);
  const handleUpload = () => {
    setUploadingVideo(true);
    setUploadVideo(false);
  };
  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img
                  src={close}
                  alt="close"
                  onClick={() => {
                    setUploadingVideo(false);
                    setUploadVideo(false);
                  }}
                />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add video</h4>
              <p>Upload a video from a URL link.</p>
              <form action="" className="upload_book">
                <div className="input-link my-40 mb-24">
                  <div className="link-text">
                    <input
                      className="link-input"
                      placeholder="Paste the link..."
                      type="text"
                    />
                  </div>
                </div>
                <div className="modal-btn">
                  <button
                    type="button"
                    className="btn-black_create "
                    onClick={handleUpload}
                  >
                    Upload from URL
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadVideo;
